export default __webpack_public_path__ + "media/images/mailer/icon_file_download.png";